<div class="fe-capacities-container">
  <!-- ================= ACTION BAR ================= -->
  <div class="table-actions-bar">
    <div class="table-title">FE Flow Network</div>

    <button *ngIf="hasAnyActiveFilters()" (click)="clearAllFilters()">
      Clear Filters
    </button>
    <button (click)="saveRows()" [disabled]="!data.length">Save</button>
    <button (click)="openExportDialog()" [disabled]="!data.length">Export</button>
  </div>

  <!-- ================= SPINNER ================= -->
  <div class="spinner-container">
    <mat-spinner *ngIf="spinnerBoolean"></mat-spinner>
  </div>

  <!-- ================= TABLE ================= -->
  <div class="table-container" *ngIf="!spinnerBoolean && !recordNotFound">
    <!-- ================= HEADER ================= -->
    <div class="table-header-container">
      <div class="table-header-row">
        <div class="table-header-cell" *ngFor="let col of columns">
          <div class="col-wrap">
            <div>{{ col.header }}</div>

            <div *ngIf="col.filterable" style="margin-left: 5px">
              <ng-container
                *ngIf="col.field === 'wellPropId'; else normalFilterIcon"
              >
                <img
                  class="filter-icon"
                  [ngClass]="{
                    'active-filter-icon': isFilterApplied(col.field)
                  }"
                  src="../../assets/img/search.png"
                  width="16"
                  height="16"
                  (click)="openFloatingFilter($event, col.field)"
                />
              </ng-container>

              <ng-template #normalFilterIcon>
                <img
                  class="filter-icon"
                  [ngClass]="{
                    'active-filter-icon': isFilterApplied(col.field)
                  }"
                  src="../../assets/img/Filter.png"
                  width="16"
                  height="16"
                  (click)="openFloatingFilter($event, col.field)"
                />
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ================= BODY ================= -->
    <div class="table-body-container">
      <cdk-virtual-scroll-viewport
        itemSize="56"
        class="virtual-scroll-viewport"
        (scrolledIndexChange)="onScroll($event)"
      >
        <div
          class="table-body-row"
          *cdkVirtualFor="let row of filteredData; trackBy: trackByRowId"
        >
          <div
            class="table-header-cell"
            *ngFor="let col of columns"
            [ngClass]="{
              'non-editable-cell': !col.editable,
              'cs-cell': col.field === 'cs'
            }"
            [title]="getColumnTooltip(row, col)"
          >
            <div class="cell-wrapper">
              <!-- ============ CTB TRAIN LOOKUP ============ -->
              <ng-container
                *ngIf="
                  col.editable && col.lookup && col.field === 'ctbTrain';
                  else normalLookup
                "
              >
                <select
                  [(ngModel)]="row[col.field]"
                  (focus)="handleTrainFocus(row)"
                  (ngModelChange)="onTrainChange(row)"
                >
                  <option value="">-- Select --</option>
                  <option
                    *ngFor="let option of getTrainOptions(row)"
                    [value]="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </ng-container>

              <!-- ============ OTHER LOOKUPS ============ -->
              <ng-template #normalLookup>
                <ng-container *ngIf="col.editable && col.lookup; else textCell">
                  <select
                    [(ngModel)]="row[col.field]"
                    (focus)="handleLookupFocus(row)"
                    (ngModelChange)="onLookupChange(row, col.field)"
                  >
                    <option value="">-- Select --</option>
                    <option
                      *ngFor="
                        let option of getDynamicLookupOptions(row, col.field)
                      "
                      [value]="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </ng-container>
              </ng-template>

              <!-- ============ TEXT CELL ============ -->
              <ng-template #textCell>
                <ng-container *ngIf="col.editable; else readonly">
                  <input
                    type="text"
                    [(ngModel)]="row[col.field]"
                    (focus)="beginRowEdit(row)"
                    (ngModelChange)="markRowAsEdited(row)"
                  />
                </ng-container>
              </ng-template>

              <!-- ============ READONLY ============ -->
              <ng-template #readonly>
                <span>{{ row[col.field] || "-" }}</span>
              </ng-template>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

  <!-- ================= NO RECORDS ================= -->
  <div
    *ngIf="!spinnerBoolean && recordNotFound"
    class="record-not-found-message"
  >
    No records found for this WellPropID.
  </div>

  <!-- ================= FLOATING FILTER ================= -->
  <div
    class="floating-filter-dropdown"
    *ngIf="showFloatingFilter"
    [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }"
  >
    <!-- SEARCH -->
    <input
      type="text"
      [(ngModel)]="filterSearch[activeFilter]"
      [placeholder]="
        activeFilter === 'wellPropId' ? 'Enter full WellPropID' : 'Search...'
      "
    />

    <div class="filter-options">
      <!-- ===== PAD FILTER (20K OPTIONS) ===== -->
      <cdk-virtual-scroll-viewport
        *ngIf="activeFilter === 'pad'"
        itemSize="56"
        class="filter-virtual-viewport"
      >
        <div
          *cdkVirtualFor="
            let option of getFilteredDropdownOptions(activeFilter);
            trackBy: trackByFilterOption
          "
          class="filter-option"
        >
          <label>
            <input
              type="checkbox"
              [checked]="isChecked(activeFilter, option)"
              (change)="toggleMultiFilter(activeFilter, option, $event)"
            />
            <span>{{ getFilterOptionLabel(option) }}</span>
          </label>
        </div>
      </cdk-virtual-scroll-viewport>

      <!-- ===== ALL OTHER FILTERS ===== -->
      <ng-container *ngIf="activeFilter !== 'pad'">
        <label *ngFor="let option of getFilteredDropdownOptions(activeFilter)">
          <input
            type="checkbox"
            [checked]="isChecked(activeFilter, option)"
            (change)="toggleMultiFilter(activeFilter, option, $event)"
          />
          <span>{{ getFilterOptionLabel(option) }}</span>
        </label>
      </ng-container>
    </div>

    <!-- ACTIONS -->
    <div class="filter-buttons">
      <button (click)="applyFilter(activeFilter)">Apply</button>
      <button (click)="clearFilter(activeFilter)">Clear</button>
    </div>
  </div>

  <!-- ================= LOADER ================= -->
  <div *ngIf="isLoading" class="loader-overlay">
    <div class="loader"></div>
  </div>
</div>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export FE Flow Network</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #bulkUpdateDialog>
  <div class="dialog-container flow-network-dialog-container">
    <h2 class="dialog-title flow-network-dialog-title">Save Options</h2>
    <div class="dialog-content flow-network-dialog-content">
      <p>
        Choose how you want to save these changes.
      </p>
      <p>
        Save only the edited rows, or apply the same update to all rows with
        the same pad name.
      </p>
    </div>
    <div class="flow-network-dialog-actions">
      <button class="secondary-action" [mat-dialog-close]="false">
        Save Edited Rows Only
      </button>
      <button class="primary-action" [mat-dialog-close]="true">
        Update All Matching Pad Rows
      </button>
    </div>
  </div>
</ng-template>
